export default function ZoomEvent(target, type, transform) {
  this.target = target;
  this.type = type;
  this.transform = transform;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-zoom/src/event.js
// module id = ../../../../d3-zoom/src/event.js
// module chunks = 4